export const URL_REQUEST_ACCESS_TO_RESTRICTED_AUCTION = 'https://marketplace.autura.com/rda-reg';

export const URL_LEARN_MORE_RESTRICTED_ACCESS = 'https://support.marketplace.autura.com/hc/en-us/articles/360055270252';
export const URL_SUPPORT_BIDDING_LIMITS_PER_AUCTION =
    'https://support.marketplace.autura.com/hc/en-us/articles/18592446634893-Bidding-Limits';
// TODO: update with correct url
export const URL_SUPPORT_BIDDING_LIMITS_GLOBAL =
    'https://support.marketplace.autura.com/hc/en-us/articles/18592446634893-Bidding-Limits';
export const URL_CONTACT_SUPPORT = 'https://support.marketplace.autura.com/hc/en-us';
